module.exports = __webpack_public_path__ + "img/article1.fc006c35.jpeg";